












import ApplicationLayoutFluid from "@/layouts/ApplicationLayoutFluid.vue";
import SuggestedRateSearch from "@/views/suggested-rate/partials/SuggestedRateSearch.vue";
import { ApplicationState } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  name: "SuggestedRate",
  components: {
    ApplicationLayoutFluid,
    SuggestedRateSearch
  }
})
export default class SuggestedRate extends Vue {
  // ===== Store ===== //
  @State("application") public application!: ApplicationState;
}
